module.exports = __webpack_public_path__ + "img/account_icon.35a6f1c7.svg";